import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Learner' },
    { value: 2, label: 'Staff' },
    { value: 3, label: 'Caregiver' },
    { value: 4, label: 'Doctors and Specialists' },
    { value: 15, label: 'LINC-ED' },
  ],
});
